import Openable from './lib/openable';

export default class extends Openable {
  protected getActiveClass() {
    return 'drawer--active';
  }
}
